import cn from "classnames"
import { useAtom } from "@reatom/npm-react"
import { KeyboardEvent } from "react"

import { RadioGroup } from "ui-kit/components-branded/index"
import { Choices } from "modules/NewClientSurvey/common"
import { answersAtom } from "modules/NewClientSurvey/common/models"
import style from "modules/NewClientSurvey/components/Select/List/style.module.scss"

interface Props {
    className?: string
    questionId: string
    choices: Choices[]
    onClickItem: (index: string) => void
}

export function List({ className, questionId, choices, onClickItem }: Props) {
    const [answers] = useAtom(answersAtom)

    function handleOnKeyUp(e: KeyboardEvent<HTMLDivElement>, id: string) {
        if (e.key === "Enter") {
            onClickItem(id)
        }
    }

    return (
        <div className={cn(style.container, className)}>
            <RadioGroup>
                {choices.map((item, _) => {
                    const value = answers[questionId]?.value
                    const checked = String(value) === item.id

                    return (
                        <RadioGroup.Item
                            className={style.item}
                            defaultChecked={checked}
                            showCheck={false}
                            key={item.id}
                            name={item.id}
                            value={item.id}
                            onClick={() => onClickItem(item.id)}
                            onKeyUp={(e) => handleOnKeyUp(e, item.id)}
                        >
                            <div className={style.header}>
                                {item.image && (
                                    <span className={style.emoji}>
                                        <img src={item.image} alt="" />
                                    </span>
                                )}
                                {item.title}
                            </div>
                            {item.comment && (
                                <div className={style.footer}>
                                    {item.comment && (
                                        <div className={style.comment}>{item.comment}</div>
                                    )}
                                </div>
                            )}
                        </RadioGroup.Item>
                    )
                })}
            </RadioGroup>
        </div>
    )
}
